// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
}

.dropdown-menu {
  margin-top: 20px;
  padding: 12px 0;
  position: absolute;
  top: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  z-index: 1050;
  width: max-content;
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.dropdown-menu.show {
  opacity: 1;
  transform: translateY(0);
}
.dropdown-menu li {
  list-style: none;
  padding: 10px 20px;
  transition: background 0.3s ease-in-out;
}
.dropdown-menu li:hover {
  background: #f4f6ff;
}
.dropdown-menu li a {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.dropdown-menu li a .title {
  font-size: 18px;
  color: #171717;
}
.dropdown-menu li a .desc {
  font-size: 14px;
  color: #6c757d;
  margin-top: 2px;
}
.dropdown-menu li a:hover {
  color: #0080ff;
}
.dropdown-menu li a:hover .title {
  color: #0080ff;
}
.dropdown-menu li a:hover .desc {
  color: #828bb2;
}

.dropdown-item:focus,
.dropdown-item:active {
  background-color: transparent !important;
  color: inherit !important;
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/navbar/products-dropdown/products-dropdown.component.scss"],"names":[],"mappings":"AA6CA;EACE,kBAAA;AA5CF;;AA+CA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,kDAAA;AA5CF;AA8CE;EACE,UAAA;EACA,wBAAA;AA5CJ;AA+CE;EACE,gBAAA;EACA,kBAAA;EACA,uCAAA;AA7CJ;AA+CI;EACE,mBAAA;AA7CN;AAgDI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AA9CN;AAgDM;EACE,eAAA;EACA,cAAA;AA9CR;AAiDM;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA/CR;AAkDM;EACE,cAAA;AAhDR;AAkDQ;EACE,cAAA;AAhDV;AAmDQ;EACE,cAAA;AAjDV;;AAwDA;;EAEE,wCAAA;EACA,yBAAA;EACA,wBAAA;AArDF","sourcesContent":["// :host {\r\n//   position: relative;\r\n// }\r\n\r\n// .dropdown-menu {\r\n//   margin-top: 27px;\r\n//   margin-right: 40px;\r\n//   display: none;\r\n//   position: absolute;\r\n//   top: 100%;\r\n//   background-color: #7f83ff;\r\n//   box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n//   z-index: 1050; /* Ensure this is higher than the other components */\r\n//   width: max-content; /* Adjust the width as needed */\r\n\r\n//   li {\r\n//     border-bottom: 1px solid #626262;\r\n\r\n//     a {\r\n//       color: #f0f1fa;\r\n//       font-size: 22px;\r\n//       padding-top: 15px;\r\n\r\n//       .desc {\r\n//         color: #333333;\r\n//         margin-top: 5px; /* Default color */\r\n//       }\r\n\r\n//       &:hover {\r\n//         background-color: #f0f1fa;\r\n//         color: #7f83ff;\r\n\r\n//         .desc {\r\n//           color: gray;\r\n//         }\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n\r\n// .show {\r\n//   display: block;\r\n// }\r\n\r\n\r\n:host {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-menu {\r\n  margin-top: 20px;\r\n  padding: 12px 0;\r\n  position: absolute;\r\n  top: 100%;\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);\r\n  z-index: 1050;\r\n  width:  max-content;\r\n  opacity: 0;\r\n  transform: translateY(-10px);\r\n  transition: opacity 0.3s ease, transform 0.3s ease;\r\n\r\n  &.show {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n\r\n  li {\r\n    list-style: none;\r\n    padding: 10px 20px;\r\n    transition: background 0.3s ease-in-out;\r\n\r\n    &:hover {\r\n      background: #f4f6ff;\r\n    }\r\n\r\n    a {\r\n      display: flex;\r\n      flex-direction: column;\r\n      text-decoration: none;\r\n      color: #333;\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n\r\n      .title {\r\n        font-size: 18px;\r\n        color: #171717;\r\n      }\r\n\r\n      .desc {\r\n        font-size: 14px;\r\n        color: #6c757d;\r\n        margin-top: 2px;\r\n      }\r\n\r\n      &:hover {\r\n        color: #0080ff;\r\n\r\n        .title {\r\n          color: #0080ff;\r\n        }\r\n\r\n        .desc {\r\n          color: #828bb2;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-item:focus,\r\n.dropdown-item:active {\r\n  background-color: transparent !important;\r\n  color: inherit !important;\r\n  outline: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
